import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

import Live from '@/views/live/index'
// import Star from '@/views/star/index'
import Activity from '@/views/activity/index'
import Ranking from '@/views/ranking/index'
import Store from '@/views/store/index'
import StoreTask from "@/views/activity/index.vue";
import StoreMall from "@/views/store/mall.vue";
import StoreDedicate from "@/views/store/dedicate.vue";
// import Apply from '@/views/apply/index'
import Schedule from '@/views/schedule/index'
import Prize from '@/views/prize/index'
import Teams from '@/views/teams/index'
import Detail from '@/views/teams/detail'
import DetailClan from '@/views/teams/detail-team'
import DetailMembers from '@/views/teams/detail-teamer'
import DetailFanRanking from '@/views/teams/detail-fan'

import Quiz from '@/views/quiz/index'

Vue.use(Router)

const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			redirect: { name: 'Live' }
		},
		// {
		// 	path: '/star',
		// 	name: 'Star',
		// 	component: Star
		// },
		{
			path: '/activity',
			name: 'Activity',
			component: Activity
		},
		{
			path: '/prize',
			name: 'Prize',
			component: Prize
		},
		{
			path: '/store',
			name: 'Store',
			component: Store,
			redirect: { name: 'StoreTask' },
			children: [
				{
					path: 'task',
					name: 'StoreTask',
					component: StoreTask,
				},
				{
					path: 'mall',
					name: 'StoreMall',
					component: StoreMall,
				},
				{
					path: 'dedicate',
					name: 'StoreDedicate',
					component: StoreDedicate,
				},
			]
		},
		// {
		// 	path: '/apply',
		// 	name: 'Apply',
		// 	component: Apply
		// },
		{
			path: '/schedule',
			name: 'Schedule',
			component: Schedule
		},
		{
			path: '/live',
			name: 'Live',
			component: Live
		},
		{
			path: '/teams',
			name: 'Teams',
			component: Teams
		},
		{
			path: '/ranking',
			name: 'Ranking',
			component: Ranking
		},
		{
			path: '/teams/:id',
			name: 'Detail',
			component: Detail,
			redirect: { name: 'DetailClan' },
			children: [
				{
					path: 'clan',
					name: 'DetailClan',
					component: DetailClan
				},
				{
					path: 'members',
					name: 'DetailMembers',
					component: DetailMembers
				},
				{
					path: 'fan',
					name: 'DetailFanRanking',
					component: DetailFanRanking
				}
			]
		},
		{
			path: '/quiz',
			name: 'Quiz',
			component: Quiz
		}
	]
})

// 报名阶段, 所有路由全部重定向到报名界面
const state = store.state;
if(state.registration.switch && !state.registration.testOtherModule) {
	router.beforeEach((to, from, next) => {
		if(from.name == 'Schedule') {
			return;
		} else {
			if(to.name !== 'Schedule') {
				next({ name: 'Schedule' })
			} else {
				next()
			}
		}
	})
}

export default router;